import EnhancedCodeEditor from './enhancedCodeEditor';
import ContextMenuHandler from './contextMenu';

export default class CodeModeCommand {
  /**
   * The command to run on button click
   */
  static name = 'preset-mautic:code-edit';

  static codeEditor;
  static contextMenuHandler;

  static launchCodeEditorModal(editor, sender, opts = {}) {
    if (!editor) {
      throw new Error('no editor');
    }

    // Initialize context menu handler if not already done
    if (!CodeModeCommand.contextMenuHandler) {
      CodeModeCommand.contextMenuHandler = new ContextMenuHandler(editor);
    }

    // Check if there's a target component stored in editor
    const targetComponent = opts.targetComponent || editor._targetComponentForCodeEditor;

    // Merge options with target component
    const editorOpts = {
      ...opts,
      ...(targetComponent && { targetComponent })
    };

    // Clear the stored target component
    if (editor._targetComponentForCodeEditor) {
      delete editor._targetComponentForCodeEditor;
    }

    // Create enhanced code editor with optional target component
    CodeModeCommand.codeEditor = new EnhancedCodeEditor(editor, editorOpts);

    // Deactivate sender button if it has a set method (only for panel buttons)
    if (sender && typeof sender.set === 'function') {
      sender.set('active', 0);
    }

    // Show the enhanced editor
    CodeModeCommand.codeEditor.show();

    // Transform DC Component to token
    editor.runCommand('preset-mautic:dynamic-content-components-to-tokens');
  }

  static stopCodeEditorModal(editor) {
    if (!editor) {
      throw new Error('no editor');
    }
    // Transform Token to Components
    editor.runCommand('preset-mautic:update-dc-components-from-dc-store');
  }
}
